import { create } from 'zustand';

interface MiniCartUIState {
  isOpen: boolean;
  /** Auto-close timer id so we can cancel/reset if another item is added. */
  closeTimer: ReturnType<typeof setTimeout> | null;
  /** Senast tillagda produkten — styr "Kom du ihåg?" i rutan. */
  lastAddedId: number | null;
  open: (productId?: number) => void;
  close: () => void;
}

/**
 * Lightweight UI state for the post-add slideout. Kept separate from the cart
 * data store so cart changes don't re-render the slideout, and vice versa.
 */
export const useMiniCartUI = create<MiniCartUIState>((set, get) => ({
  isOpen: false,
  closeTimer: null,
  lastAddedId: null,

  open: (productId) => {
    // Cancel any pending auto-close — a fresh add resets the timer.
    const t = get().closeTimer;
    if (t) clearTimeout(t);
    // Längre tid när det finns komplement att titta på — 7 s räckte inte
    // för att läsa "Kom du ihåg?" och trycka Köp.
    const next = setTimeout(() => set({ isOpen: false, closeTimer: null }), 12000);
    set({ isOpen: true, closeTimer: next, ...(productId !== undefined ? { lastAddedId: productId } : {}) });
  },

  close: () => {
    const t = get().closeTimer;
    if (t) clearTimeout(t);
    set({ isOpen: false, closeTimer: null });
  },
}));
